import { UseQueryOptions, useQuery } from "@tanstack/react-query"
import { IEvent } from "../types"
import { IAccident, IMemberFeedback, ITimeline } from "./types"

export function useEvent(eventId: string, config?: UseQueryOptions<IEvent>) {
  return useQuery<IEvent>(
    ["operation", "production", "events", "external", eventId],
    {
      ...config,
    }
  )
}

export function useTimeline(
  eventId: string,
  memberId: string,
  config?: UseQueryOptions<ITimeline>
) {
  return useQuery<ITimeline>(
    [
      "operation",
      "production",
      "events",
      "execution",
      eventId,
      "members",
      memberId,
      "timeline",
    ],
    config
  )
}

export function useAccident(
  memberId: string,
  accidentId: string,
  config?: UseQueryOptions<IAccident>
) {
  return useQuery<IAccident>(
    [
      "operation",
      "administration",
      "members",
      memberId,
      "accident",
      accidentId,
    ],
    config
  )
}

export function useMemberFeedback(
  member_id: string,
  event_id: string,
  config?: UseQueryOptions<IMemberFeedback>
) {
  return useQuery<IMemberFeedback>(
    [
      "operation",
      "administration",
      "members",
      member_id,
      "events",
      event_id,
      "feedback",
    ],
    config
  )
}
